import { createContext } from "react";

/**
 * What is wrong with the filter in force, as sentences (#518).
 *
 * `SectionPage` fills it from `validateFilter` for the filter in the URL, and
 * `NoMatches` reads it, so every list's "Nothing matches" can say *why* when the
 * answer is a clause that can never match — a date range that runs backwards, a
 * range with one end missing — instead of "No rows match the current filter"
 * under a chip that looks fine. Context rather than a prop because
 * `NoMatches` is drawn by a dozen list screens, none of which should have to
 * know about it. Empty outside a section, which says nothing extra.
 */
export const FilterProblemsContext = createContext<readonly string[]>([]);
